import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import { filter, map, take } from 'rxjs/operators';
import { ConfigurableFormComponent } from '../../../shared/modules/configurable-form/containers/configurable-form/configurable-form.component';
import { OnFieldChanged } from '../../../shared/modules/configurable-form/models/on-field-changed';
import { OneClickSelectPointOfDeliveriesAction } from '../../actions/one-click-pods.actions';
import { OneClickResetProductsAction } from '../../actions/one-click-products.actions';
import { State } from '../../reducers';
import { getOneClickPointOfDeliveries } from '../../selectors/one-click-point-of-deliveries.selector';
import { OneClickBuilderField } from '../../util/constants/builder-fields';

@Injectable()
export class OneClickSyncPointOfDeliveriesLoadProducts implements OnFieldChanged {
  constructor(private store: Store<State>) {}

  onFieldChanged(value: number, formGroup: UntypedFormGroup, form: ConfigurableFormComponent): void {
    this.resetDefaults(formGroup);
    this.store
      .pipe(
        select(getOneClickPointOfDeliveries),
        filter((pods) => !!value && !!pods.length),
        take(1),
        map((pods) => pods.find((shippingDestination) => shippingDestination.shippingDestinationId === value)),
      )
      .subscribe((pod) => {
        this.store.dispatch(new OneClickResetProductsAction());
        pod && this.store.dispatch(new OneClickSelectPointOfDeliveriesAction(pod));
      });
  }

  private resetDefaults(formGroup: UntypedFormGroup) {
    const fieldsToReset = [
      OneClickBuilderField.Product,
      OneClickBuilderField.Plant,
      OneClickBuilderField.Payment,
      OneClickBuilderField.Unit,
      OneClickBuilderField.StandardLot,
    ];

    fieldsToReset.forEach((field) => formGroup.controls[field] && formGroup.controls[field].setValue(undefined));
  }
}
